// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { NavController }      from 'ionic-angular';
import { ToastController }    from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { Loading }            from 'ionic-angular';
import { GoogleAnalytics }    from '@ionic-native/google-analytics';

// External modules
import { TranslateService }   from '@ngx-translate/core';

// Models
import { Language }           from '../../shared/models/language';

// Services
import { LangService }        from '../../shared/providers/lang-service';
import { ApplicationService } from '../../shared/providers/application-service';
import { StorageHelper } from '../../shared/helpers/storage.helper';

@Component({
  selector    : 'page-settings',
  templateUrl : 'settings.html',
  providers   : [ LangService, ApplicationService ]
})
export class SettingsPage
{
  lang         : string     = 'en-GB';
  unit         : string     = 'metric';
  languages    : Language[] = [];
  user         : any        = null;
  waitingLabel : string     = "Please wait...";

  constructor(public navCtrl            : NavController,
              public toastCtrl          : ToastController,
              public loadingCtrl        : LoadingController,
              public langService        : LangService,
              public translate          : TranslateService,
              public applicationService : ApplicationService,
              public menuCtrl           : MenuController,
              private analytics         : GoogleAnalytics)
  {
    this.initTranslations();

    this.user = StorageHelper.getUser();
    this.initLanguages();
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Settings ");
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  initTranslations()
  {
    this.translate.get('PLEASE_WAIT').subscribe(value =>
    {
      this.waitingLabel = value;
    });
  }

  public presentLoading() : Loading
  {
    let loader = this.loadingCtrl.create({
      content: this.waitingLabel
    });
    return loader;
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  public initLanguages() : void
  {
    let loader = this.presentLoading();
    loader.present();

    const languages = StorageHelper.getLanguages();
    if(languages != null)
    {
      this.languages = languages;
      this.getSelectedLang();
      this.getSelectedUnit();
    }
    else
    {
      this.presentToast("Missing mixtures, please synchronize before.");
    }
    loader.dismiss();
  }

  async getSelectedLang()
  {
    const lang = await this.applicationService.getSelectedLanguage()
    this.lang = lang;
  }

  public getSelectedUnit() : void
  {
    this.unit = StorageHelper.getUnit();
  }

  public updateSelectedLang($event) : void
  {
    const isValidCode = this.languages.some((item) => item.Code == $event);
    if(!isValidCode)
    {
      this.presentToast("Missing mixtures, please synchronize before.");
      this.lang = 'en-GB';
      return;
    }

    StorageHelper.setSelectedLanguage($event);
    this.changeLanguage($event);
  }

  public changeLanguage($event) : void
  {
    this.translate.use($event);
  }

  public updateSelectedUnit($event) : void
  {
    this.setUnitMode();
  }

  public setUnitMode() : void
  {
    StorageHelper.setUnit(this.unit);
  }

  public setLangMode() : void
  {
    StorageHelper.setSelectedLanguage(this.lang);
    this.changeLanguage(this.lang);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings.ts